module.exports = __webpack_public_path__ + "img/sub-banner.2558f25b.jpg";